/** @jsx isolateComponent */

import { Fragment } from 'react';

import { AsyncIndicator } from '@zapier/common-components';
import { isolateComponent } from '@zapier/common-utils';
import { Link } from '@zapier/design-system';
import { useTrackingContext } from '@zapier/toolbox-tracking';

import { Price } from '@zapier/design-system-revenue/src/components/other';

import {
  EVENT_TRACK_TRIAL_BANNER,
  PRICING_PAGE_URL,
} from '@zapier/design-system-revenue/src/constants';

import { buildUpgradeUrl } from '@zapier/design-system-revenue/src/utils';

import { useData as _useData } from './useData';

type Props = {
  /** For dependency injection testing only */
  useData?: () => ReturnType<typeof _useData>;
};

export const ProfessionalTrialEndedBanner = ({ useData = _useData }: Props) => {
  const {
    currentPlanName,
    error,
    isLoading,
    nextPlanAmount,
    nextPlanInterval,
    nextPlanName,
  } = useData();

  const { trackEvent } = useTrackingContext();

  if (isLoading) {
    return <AsyncIndicator />;
  }

  if (error) {
    return <Fragment>{error}</Fragment>;
  }

  const url = nextPlanName
    ? buildUpgradeUrl(currentPlanName, nextPlanName, nextPlanInterval)
    : PRICING_PAGE_URL;

  return (
    <Fragment>
      <Link
        href={url}
        onClick={() =>
          trackEvent(EVENT_TRACK_TRIAL_BANNER, {
            in_trial: false,
          })
        }
      >
        Upgrade now
        {nextPlanAmount && (
          <span>
            {' '}
            for <Price>{nextPlanAmount}</Price>
          </span>
        )}
      </Link>{' '}
      to use Filters, Formatters, Lead Score, and much more!
    </Fragment>
  );
};
